/**
 *
 * @param str texto tratado.
 * @returns null ou o valor original.
 */
export const treatsNullUndefinedEmpyt = (str: any): null | any => {
    return str === '' || str === null || str === 'null' || str === undefined || str === 'undefined' ? null : str;
};


/**
 *
 * @param str texto de tratamento.
 * @returns true, false ou undefined.
 */
export const treatsFalseTrue = (str: any): null | any => {
    if (str && str === 'true') {
        return true;
    } else if (str && str === 'false') {
        return false;
    } else {
        return undefined;
    }
};
